/* eslint-disable */
import {
  InvoiceViewDetails,
  InvoiceHistory,
  InvoiceListResponse,
  InvoiceEditDetails,
  InvoiceEmployeeDetails,
  ExpenseViewDetails,
} from 'src/interfaces';
import http from './http';
import axios, { AxiosError } from 'axios';

class ExpenseService {
  static addExpense(formData: FormData) {
    return http
      .post(`/expense/create`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static getExpenseDetails(params: any): Promise<ExpenseViewDetails> {
    return http.get(`/expense/detail/${params.expenseId}`).then(resp => resp.data);
  }

  static getExpenseById(params: any): Promise<ExpenseViewDetails> {
    return http.get(`/expense/detail/${params.expenseId}`).then(resp => resp.data);
  }

  static getExpenseList(params: any): Promise<any> {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        searchParams.append(key, String(value));
      }
    });

    return http.get(`expense/my-expenses?${searchParams.toString()}`).then(resp => resp.data);
  }

  static getAssignments() {
    return http
      .get(`/assignment/fetch`)
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static getAssignmentsPersonalNumber() {
    return http
      .get(`/assignment/fetch/personnelNumber`)
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static getEmployee(): Promise<InvoiceEmployeeDetails> {
    return http.get(`/expense/employee-detail`).then(resp => resp.data);
  }

  static searchClients(params: { clientSearch: string; limit?: number }) {
    let query = `clientSearch=${params.clientSearch}`;

    if (params.limit) {
      query += `&limit=${params.limit}`;
    }

    return http
      .get(`admin/assignment/clients/search?${query}`)
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          throw err;
        }
      });
  }

  static approveExpense(expenseId: string, expense: any) {
    return http
      .patch(`/expense/approve/${expenseId}`, expense, {})
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static rejectExpense(expenseId: string, invocie: any) {
    return http
      .patch(`/expense/reject/${expenseId}`, invocie, {})
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static deleteExpense(expenseId: string, expense: any) {
    return http
      .patch(`/admin/expense/delete/${expenseId}`, expense, {})
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static deleteExpenseWorker(expenseId: string, expense: any) {
    return http
      .patch(`/expense/delete/${expenseId}`, expense, {})
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static updateExpense(id: string, formData: FormData) {
    return http
      .patch(`expense/update/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }
}

export default ExpenseService;
